import * as React from "react";

import type { TooltipState } from "@fluentui/react-components";
import {
  useTooltipStyles_unstable,
  renderTooltip_unstable,
} from "@fluentui/react-components";
import type { AppTooltipProps } from "./AppTooltip.types";
import { useAppTooltip } from "./useAppTooltip";

export const AppTooltip: React.FC<AppTooltipProps> = React.memo(
  React.forwardRef<HTMLDivElement, AppTooltipProps>((props, _ref) => {
    const [visible, setVisible] = React.useState(props.tooltipVisible || false);
    const state = useAppTooltip(props, visible, setVisible);
    React.useEffect(() => {
      if (props.tooltipVisible !== undefined) {
        setVisible(props.tooltipVisible);
      }
    }, [props.tooltipVisible]);
    // Handle the Ctrl key to dismiss the tooltip
    const handleDocumentKeyDown = (event: KeyboardEvent): void => {
      if (event.key === "Control") {
        setVisible(false);
      }
    };
    React.useEffect((): (() => void) => {
      window.addEventListener("keydown", handleDocumentKeyDown);
      return (): void =>
        window.removeEventListener("keydown", handleDocumentKeyDown);
    }, []);

    useTooltipStyles_unstable(state as TooltipState);
    return renderTooltip_unstable(state as TooltipState);
  })
);
